import script from "./scheduleClass.vue?vue&type=script&setup=true&lang=js"
export * from "./scheduleClass.vue?vue&type=script&setup=true&lang=js"

import "./scheduleClass.vue?vue&type=style&index=0&id=1e9523d4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9523d4"]])

export default __exports__